import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import JQLBuilderAdvanced from '@atlassian/jira-jql-builder-advanced/src/async';

export type JqlEditorProps = {
	jql: string;
	// The new JQL editor doesn't auto focus, but arguably it should (the UX is a bit off without it)
	// so we keep this prop in the hopes that one day we can use it again.
	autoFocus?: boolean;
	onJqlChanged: (arg1: string) => void;
	ariaDescribedBy: string;
};

const EXCLUDED_AUTOCOMPLETE_FIELDS = ['project'];

export const JqlEditor = ({ jql, autoFocus, onJqlChanged, ariaDescribedBy }: JqlEditorProps) =>
	fg('fix_jsmca11y-502_issue') ? (
		<div aria-describedby={ariaDescribedBy}>
			<JQLBuilderAdvanced
				analyticsSource="jsm-sla-configuration"
				query={jql}
				autoFocus={autoFocus}
				onUpdate={onJqlChanged}
				excludedAutocompleteFields={EXCLUDED_AUTOCOMPLETE_FIELDS}
			/>
		</div>
	) : (
		<JQLBuilderAdvanced
			analyticsSource="jsm-sla-configuration"
			query={jql}
			autoFocus={autoFocus}
			onUpdate={onJqlChanged}
			excludedAutocompleteFields={EXCLUDED_AUTOCOMPLETE_FIELDS}
		/>
	);
